import { Patient } from "@/Common/Models/Patient/Patient";
import { PatientPopulationBasedFundingModel } from "@/Common/Models/PopulationBasedFunding/PatientPopulationBasedFundingModel";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { PopulationBasedFundingUpdateIconSignal } from "@/Patient/Models/PopulationBasedFunding/PopulatonBasedFundingStatusControllerUpdateSignal";
import { PatientStore } from "@/Patient/Stores/PatientStore";

class PatientPopulationBasedFundingHandler extends BaseOperationHandler {
    constructor() {
        super();
        if (cacheStore.ClinicSettings.EnablePopulationBasedFunding) {
            this.RegisterOperation(LocalPatientOperations.Profile.PopulationBasedFunding_SetPatientData, this.setPatientData);
            this.RegisterOperation(LocalPatientOperations.Profile.PopulationBasedFunding_SignalIconUpdate, this.signalPopulationBasedFundingIconChange);
        }
    }

    private setPatientData(request: LocalEvent, store: PatientStore): void {
        const nextPbfModel: PatientPopulationBasedFundingModel = request.Get<PatientPopulationBasedFundingModel>("nextPbfModel");
        const contactId: string = request.Get<string>("contactId");

        store.PatientModels[contactId] = new Patient({ ...store.PatientModels[contactId], PopulationBasedFunding: nextPbfModel });
    }

    private signalPopulationBasedFundingIconChange(request: LocalEvent, store: PatientStore): void {
        const patientContactFacetId: string = request.Get<string>("patientContactFacetId");
        store.PopulationBasedFundingUpdateIconSignal = new PopulationBasedFundingUpdateIconSignal({
            version: store.PopulationBasedFundingUpdateIconSignal.version + 1,
            patientContactFacetId
        });
    }
}

export { PatientPopulationBasedFundingHandler };
